
import Template from '../../component/Template';
import SchoolIcon from '@mui/icons-material/School';
import PeopleIcon from '@mui/icons-material/People';
import Api from '../../component/Api';
import React, { useEffect, useState, useRef } from 'react';
import useAuth from '../../component/useAuth.js';
import { formatDistanceToNow, parseISO } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PDFModal from '../../component/PDFModal.js';
import 'datatables.net';
import Swal from 'sweetalert2';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import ViewApplicationModal from '../../component/ExternalCredit/ViewExternalCreditApplication.js';
import useViewApplicationModal from '../../component/ExternalCredit/useViewApplication.js';
import Select from 'react-select';
import $ from 'jquery';

const INITIAL_COUNTS = {
  faculty: 0,
  discipline: 0,
  specialisation: 0,
  course: 0,
  users: 0,
  colleges: 0,
};

function formatDate(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year}, ${hour}:${minute}`;
}

const formatRelativeDate = (dateString) => {
  const parsedDate = parseISO(dateString);
  return formatDistanceToNow(parsedDate, { addSuffix: true });
};

export default function Dashboard() {
    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/convenor/");
    }
  const { http } = Api();

  const [counts, setCounts] = useState(INITIAL_COUNTS);
  const [userlog, setUserLogData] = useState([]);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [isviewcount, setViewCount] = useState(false);
  const [isviewlog, setViewLog] = useState(false);

  const hasLogs = userlog.length > 0;

  useEffect(() => {
    if (isAuth === false) {
      navigate('/convenor/');
    }
  }, [isAuth, navigate]);



  return (
    <Template>
      <div className="container-fluid">
        <div className="row mar2">
          {isviewcount && (
            <div className="col-xxl-12 col-xl-12 box-col-12">
              <div className="row g-sm-3 height-equal-2 widget-charts">
                <div className="col-sm-3">
                  <div className="card small-widget mb-sm-0">
                    <div className="card-body primary">
                      <span className="f-light">Faculties</span>
                      <div className="d-flex align-items-end gap-1">
                        <h4>{loading ? 'Loading...' : counts.faculty}</h4>
                      </div>
                      <div className="bg-gradient">
                        <svg className="stroke-icon svg-fill">
                          <SchoolIcon sx={{ color: '#581f37' }} />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="card small-widget mb-sm-0">
                    <div className="card-body warning">
                      <span className="f-light">Disciplines</span>
                      <div className="d-flex align-items-end gap-1">
                        <h4>{loading ? 'Loading...' : counts.discipline}</h4>
                      </div>
                      <div className="bg-gradient">
                        <svg className="stroke-icon svg-fill">
                          <SchoolIcon sx={{ color: '#581f37' }} />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="card small-widget mb-sm-0">
                    <div className="card-body success">
                      <span className="f-light">Specialisations</span>
                      <div className="d-flex align-items-end gap-1">
                        <h4>{loading ? 'Loading...' : counts.specialisation}</h4>
                      </div>
                      <div className="bg-gradient">
                        <svg className="stroke-icon svg-fill">
                          <SchoolIcon sx={{ color: '#581f37' }} />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="card small-widget mb-sm-0">
                    <div className="card-body secondary">
                      <span className="f-light">Courses</span>
                      <div className="d-flex align-items-end gap-1">
                        <h4>{loading ? 'Loading...' : counts.course}</h4>
                      </div>
                      <div className="bg-gradient">
                        <svg className="stroke-icon svg-fill">
                          <SchoolIcon sx={{ color: '#581f37' }} />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {error && (
            <div className="col-12 mt-2">
              <div className="alert alert-warning" role="alert">
                {error}
              </div>
            </div>
          )}
        </div>
      </div>
    </Template>
  );
}